import React from 'react'
import { Provider } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import { store } from './store'
import { router } from './router'
import { HelmetProvider } from 'react-helmet-async'
import './App.css'

function App() {
    return (
        <React.StrictMode>
            <Provider store={store}>
                <HelmetProvider>
                    <RouterProvider router={router} />
                </HelmetProvider>
            </Provider>
        </React.StrictMode>
    )
}

export default App
